import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Card, CardActions, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid, TextField, Typography } from '@mui/material'
import { Controller, useForm } from "react-hook-form";
import { AxiosInstance, FormActions } from "../../utils/constants";
import * as yup from "yup";
import { InputWithLabel, SelectInputWithLabel } from "./custom-imputs";
import { useEffect, useState } from "react";


const validatorShema = yup.object({
    clave: yup.string().required().min(6).notOneOf(["123456"]),
    repite_clave: yup.string().required().test(
        "_not_equal",
        "La contraseña es diferente a la anterior",
        function(item){
           return this.parent.clave === item
        }
     ),
});

export const FormPerfil = ({
    isOpened,
    onSendData,


    
})=>{

    const { control, register, handleSubmit, formState: { errors },setValue } = useForm({
        resolver: yupResolver(validatorShema),
        defaultValues: {  
            usuario:null,
            correo:null,
            telefono:null,
            rol:null
        }
    });

 
    useEffect(()=>{
        loadInitData();
    },[]);

    const loadInitData = async()=>{
        const {data:{value}} = await  AxiosInstance.get("sesion/obtener-datos-usuario");
            console.log({
                usuario:value.usuario,
                correo:value.email,
                telefono:value.celular,
                rol:value.perfil.descripcion
    
            });
            setValue("usuario",value.usuario);
            setValue("correo",value.email);
            setValue("telefono",value.celular);
            setValue("rol",value.perfil.descripcion);
    }

    const onSubmitForm = (data)=>{
        console.log({data});
        onSendData(data);
    }

    console.log({errors});
    return (
        <Card
        open={isOpened}
        >
           
            <CardContent>

                <form onSubmit={handleSubmit(onSubmitForm)} >
                    <Grid container spacing={1} >
                        <Grid item xs={12} sm={12} md={12} >
                           
                            <Typography variant="h3" >Mis datos personales</Typography>
                           
                        </Grid>
                      
                        <Grid item xs={12} sm={12} md={12} >

                                <Controller
                                control={control}
                                name="usuario"
                                render={({field})=>{
                                    console.log({field});
                                    return <InputWithLabel disabled size='small' label="Usuario"   {...field} />
                                }}
                                />

                        </Grid>
                        <Grid item xs={12} sm={12} md={12} >

                                <Controller
                                    control={control}
                                    name="correo"
                                    render={({field})=><InputWithLabel disabled size='small' label="Correo"   {...field} />}
                                />

                        </Grid>
                        <Grid item xs={12} sm={12} md={12} >

                                <Controller
                                    control={control}
                                    name="telefono"
                                    render={({field})=><InputWithLabel disabled size='small' label="Telefono"   {...field} />}
                                />

                        </Grid>
                        <Grid item xs={12} sm={12} md={12} >

                        <Controller
                            control={control}
                            name="rol"
                            render={({field})=><InputWithLabel  disabled size='small' label="Rol"   {...field} />}
                        />

                        </Grid>
                        <Grid item xs={12} sm={12} md={12} >

                                <Controller
                                    control={control}
                                    name="clave"
                                    render={({field})=><InputWithLabel  type="password" size='small' label="Clave"  errorMessage={errors.clave?.message}  {...field} />}
                                />

                        </Grid>
                        <Grid item xs={12} sm={12} md={12} >

                            <Controller
                                control={control}
                                name="repite_clave"
                                render={({field})=><InputWithLabel  type="password" size='small' label="Repite la clave"  errorMessage={errors.repite_clave?.message}  {...field} />}
                            />

                        </Grid>
                       
                      
                                        
                    </Grid>
                <CardActions>
                    <Button fullWidth type="submit" size="small" variant="contained" color="primary" >Cambiar contraseña</Button>
                </CardActions>
                </form>
              
                
              
            </CardContent>
         
        </Card>
    )

}